import { PGA_COM_HOST } from 'env'

import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Confetti from 'react-dom-confetti'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined'
import PartyPopperIcon from 'components/icons/party-popper-icon'
import CircularHighlightedIcon from 'components/circular-highlighted-icon'
import CopyTextButton from 'components/copy-text-button'
import SocialSharePopover from 'components/social-share-popover'
import { useAuth } from 'lib/auth'

const confettiConfig = {
  angle: '219',
  spread: 360,
  startVelocity: '50',
  elementCount: '200',
  dragFriction: 0.12,
  duration: 3000,
  stagger: '1',
  width: '12px',
  height: '8px',
  perspective: '499px',
  colors: ['#00234B', '#AB9157', '#043362', '#BBA778'],
}

const SuccessStep = ({ slug, onCreateAnother }) => {
  const [isConfettiEnabled, setIsConfettiEnabled] = useState(false)
  const { user } = useAuth()

  useEffect(() => {
    setTimeout(() => {
      setIsConfettiEnabled(true)
    }, 500)
  })
  const groupEventLink = `${PGA_COM_HOST}/things-to-do/events/${slug}`
  return (
    <>
      <Container maxWidth="sm">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          pt={8}
        >
          <Box mb={1}>
            <CircularHighlightedIcon icon={PartyPopperIcon} />
          </Box>
          <Confetti active={isConfettiEnabled} config={confettiConfig} />
          <Typography variant="h4" style={{ fontWeight: 500 }} gutterBottom>
            Success!
          </Typography>
          <Box textAlign="center" mb={2}>
            <Typography variant="body1">
              Your event has been successfully created. You can find the event
              page below.
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center" mb={2}>
            <Typography>{groupEventLink}</Typography>
            <CopyTextButton component={IconButton} value={groupEventLink}>
              <FileCopyOutlinedIcon />
            </CopyTextButton>
            <SocialSharePopover
              url={groupEventLink}
              trigger={
                <IconButton>
                  <ShareOutlinedIcon />
                </IconButton>
              }
            />
          </Box>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={onCreateAnother}
            >
              Create Another Event
            </Button>
          </Box>
          <Button
            color="primary"
            component={Link}
            to={`${
              !user.onboarding
                ? '/pga-coach/bookings/events'
                : '/pga-coach/bookings/schedule'
            }`}
          >
            I'm Finished
          </Button>
        </Box>
      </Container>
    </>
  )
}

export default SuccessStep
